import { BalanceAdjustmentType } from 'uplisting-frontend/models/balance-adjustment';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BalanceAdjustmentValidation } from 'uplisting-frontend/validations';

export default class BalanceAdjustmentRepositoryService extends BaseRepositoryService<
  ModelRegistry['balance-adjustment']
> {
  recordName = 'balance-adjustment';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = BalanceAdjustmentValidation;

  get defaultParams() {
    return {
      type: BalanceAdjustmentType.credit,
    };
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/balance-adjustment': BalanceAdjustmentRepositoryService;
  }
}
